import Http from '../API'

const tickets = {
  state: {
    ticket_list: {},
    ticket_status: {},
    ticket_count: {},
    ticket_topics: {},
    ticket_executors: {},
  },
  getters:{
    getTicketStatus: (state) => {
      return state.ticket_status
    },
    getTicketCount: (state) => {
      return state.ticket_count
    },
    getTicketTopics: (state) => {
      return state.ticket_topics
    },
    getExecutorList: (state) => {
      return state.ticket_executors
    },
  },
  mutations: {
    ticketInfo(state, resp) {
      state.ticket_status = resp.status_list
      state.ticket_count = resp.new_tickets
      state.ticket_topics = resp.topic_list
      state.ticket_executors = resp.support_users
    }
  },
  actions: {
    async ticketsInfoList() {
      await Http.v1.getTicketsInfo((response) => {
        this.commit('ticketInfo', response.data)
        this.commit('donePreloadName', 'ticketInfo')
      })
    },
    ticketInfo () {
      this.dispatch('ticketsInfoList')

      // setInterval(() => {
      //   this.dispatch('ticketsInfoList')
      // }, this.getters.getTicketListUpdate);
    },
  }
}

export default tickets
